<nav class="cv-left-nav cv-left-nav-component"
	 [ngStyle]="{'background-color': (uiConfigStyle?.backgroundColor)}"
	 [@collapse]="{
		value: toggleState, 
		params: {width: width}
	}"
	 [ngClass]="{ 'cv-left-nav--collapsed': isCollapsed() }">

	<div class="cv-left-nav__container">
		<ul *ngFor="let nav of navItems; let i = index;"
			class="nav flex-column cv-left-nav__container-content">

			<li *ngIf="nav.title && isOpen"
				class="cv-left-nav__container__nav-item-title">
				<a>
          			<span
						  class="item-groupValue">{{ nav.title }}
					</span>

					<i *ngIf="nav.collapsible"
						class="toggle-up fas fa-angle-up action-toggle"
						[@collapse]="getCollapsedIconState(i)"
						(click)="onToggleCollapse(i)">
					</i>

					<span *ngIf="nav.collapsible" 
						class="title-badge badge badge-pill badge-light item-groupBadge">
						{{ nav.items.length }}
					</span>
				</a>
			</li>

			<div class="menu-items-container" [@collapse-up]="{value: collapsedStates.get(i)}">
				<li *ngFor="let item of nav.items"
					class="cv-left-nav__container__nav-item nav-item">

					<a class="cv-left-nav__container__nav-item__nav-link action-select"
						(click)="onRouteClick($event, item)"
						[routerLink]="canNavigate(item) ? item.route : null"
					    [class.active]="onRouterLinkActive(item) || item.active">

						<i [ngClass]="getIconClass(item)"
							class="cv-left-nav__container__nav-item__nav-link__nav-icon">
						</i>

						<span [ngStyle]="{'color': (uiConfigStyle?.item?.textColor)}"
								class="item-label item-value">{{ item.label }}</span>

						<div *ngIf="item.badge"
							 [ngStyle]="{ 'background-color': (uiConfigStyle?.menuToggle?.backgroundColor)}"
							class="badge badge-pill cv-left-nav__container__nav-item__badge item-badge">
							{{ item.badge }}
							<i *ngIf="item.badgeIcon" class="fa" [ngClass]="item.badgeIcon"></i>
						</div>
					</a>
				</li>
			</div>
		</ul>
	</div>

	<div class="cv-left-nav__container__toggle action-toggle"
		 [ngStyle]="{'background-color': (uiConfigStyle?.menuToggle?.backgroundColor)}"
		 (click)="onToggle()">
		<a class="cv-left-nav__container__toggle__link">
			<i class="cv-left-nav__container__toggle__link__icon fas fa-angle-left"
				[@collapse]="getToggleIconState()"></i>
		</a>
	</div>
</nav>
